const companyOGImage = (companyID: string) => {
  switch (companyID) {
    case '5d373e9a5cc3bb787a4a7e24':
      return 'https://canny.io/images/jane-og.png';
    default:
      return 'https://canny.io/images/canny-social.png';
  }
};

export default companyOGImage;
